"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleAiCall = exports.getZoomUrls = exports.update = exports.attachZoomMeeting = exports.cancelZoomMeeting = exports.saveZoomMeeting = exports.getScheduleInfo = exports.isUnlinkedOutlookError = exports.getClientEvent = exports.getExpertEvent = exports.getZoomNumbers = exports.notifyClients = exports.notifyExpert = exports.getScheduleRequest = exports.getTakenSlots = exports.removeExpertAvailability = exports.getExpertAvailabilities = exports.getClientAvailabilities = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var schedule_helpers_1 = require("./helpers/schedule.helpers");
function getClientAvailabilities(projectId) {
    return api_1.default.get("/api/client-to-project-availability/fetch/".concat(projectId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getClientAvailabilities = getClientAvailabilities;
function getExpertAvailabilities(eplId) {
    return api_1.default.get("/api/expert-availability-to-epl/fetch/".concat(eplId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getExpertAvailabilities = getExpertAvailabilities;
function removeExpertAvailability(availabilityId) {
    return api_1.default.delete("/api/expert-availability-to-epl/".concat(availabilityId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.removeExpertAvailability = removeExpertAvailability;
function getTakenSlots(expertId, startTimeAv, endTimeAv, eplId) {
    var baseUrl = "/api/expert-availability-to-epl/".concat(expertId, "/taken-slots");
    return api_1.default
        .get("".concat(baseUrl, "?startTime=").concat(startTimeAv, "&endTime=").concat(endTimeAv, "&eplId=").concat(eplId))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getTakenSlots = getTakenSlots;
function getScheduleRequest(eplId) {
    return api_1.default.get("/api/expert-project-link/".concat(eplId, "/request-schedule")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getScheduleRequest = getScheduleRequest;
function notifyExpert(scheduleId, scheduleData) {
    return api_1.default.post("/api/schedule/".concat(scheduleId, "/notify-expert"), scheduleData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.notifyExpert = notifyExpert;
function notifyClients(scheduleId, scheduleData) {
    return api_1.default.post("/api/schedule/".concat(scheduleId, "/notify-clients"), scheduleData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.notifyClients = notifyClients;
function getZoomNumbers() {
    return api_1.default.get("/api/schedule/zoom-numbers").then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getZoomNumbers = getZoomNumbers;
function getExpertEvent(scheduleId) {
    return api_1.default
        .get("/api/schedule/".concat(scheduleId, "/expert-event"))
        .then(api_1.extractData)
        .then(schedule_helpers_1.removeX_prefix)
        .catch(api_1.errorHandler);
}
exports.getExpertEvent = getExpertEvent;
function getClientEvent(scheduleId) {
    return api_1.default
        .get("/api/schedule/".concat(scheduleId, "/client-event"))
        .then(api_1.extractData)
        .then(schedule_helpers_1.removeX_prefix)
        .catch(api_1.errorHandler);
}
exports.getClientEvent = getClientEvent;
var isUnlinkedOutlookError = function (error) {
    return (0, get_1.default)(error, 'message', '').indexOf('Outlook account') !== -1;
};
exports.isUnlinkedOutlookError = isUnlinkedOutlookError;
function getScheduleInfo(scheduleId) {
    return api_1.default.get("/api/schedule/".concat(scheduleId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getScheduleInfo = getScheduleInfo;
function saveZoomMeeting(scheduleId, meetingData) {
    return api_1.default.put("/api/schedule/".concat(scheduleId, "/zoom-meeting"), meetingData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.saveZoomMeeting = saveZoomMeeting;
function cancelZoomMeeting(scheduleId) {
    return api_1.default.put("/api/schedule/".concat(scheduleId, "/zoom-meeting/cancel")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.cancelZoomMeeting = cancelZoomMeeting;
function attachZoomMeeting(scheduleId, attachTo) {
    return api_1.default
        .put("/api/schedule/".concat(scheduleId, "/attach-zoom-meeting/").concat(attachTo), {})
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.attachZoomMeeting = attachZoomMeeting;
function update(scheduleId, data) {
    return api_1.default.put("/api/schedule/".concat(scheduleId), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function getZoomUrls(scheduleId) {
    return api_1.default.get("/api/schedule/".concat(scheduleId, "/zoom-urls")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getZoomUrls = getZoomUrls;
function scheduleAiCall(eplId, _a) {
    var url = _a.url, deadline = _a.deadline;
    return api_1.default.post("/api/schedule/ai-call", { eplId: eplId, joinUrl: url, deadline: deadline }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.scheduleAiCall = scheduleAiCall;
var api = {
    getClientAvailabilities: getClientAvailabilities,
    getExpertAvailabilities: getExpertAvailabilities,
    removeExpertAvailability: removeExpertAvailability,
    getTakenSlots: getTakenSlots,
    getScheduleRequest: getScheduleRequest,
    attachZoomMeeting: attachZoomMeeting,
    notifyExpert: notifyExpert,
    notifyClients: notifyClients,
    getZoomNumbers: getZoomNumbers,
    getExpertEvent: getExpertEvent,
    getClientEvent: getClientEvent,
    isUnlinkedOutlookError: exports.isUnlinkedOutlookError,
    getInfo: getScheduleInfo,
    saveZoomMeeting: saveZoomMeeting,
    cancelZoomMeeting: cancelZoomMeeting,
    update: update,
    getZoomUrls: getZoomUrls,
    scheduleAiCall: scheduleAiCall,
};
exports.default = api;
